import { render, staticRenderFns } from "./Loadable.vue?vue&type=template&id=611bc89f&"
import script from "./Loadable.vue?vue&type=script&lang=js&"
export * from "./Loadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports